import { useTranslation } from 'react-i18next';

import { company } from '~/company/Company';
import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs';
import { useGlobal } from '~/hooks/useGlobal';
import type { BreadcrumbsItem } from '~/stores/CatalogStore';

import MobileHeaderLayout from '../../Main/MobileHeader/MobileHeaderLayout';
import MobileHeaderTitle from '../../Main/MobileHeader/MobileHeaderTitle';

import tp from '../textPage.module.scss';

const content = {
  ru: {
    supportTitle: 'Служба поддержки',
    emailLabel: 'Email',
    phoneLabel: 'Телефон',
    workingHours: 'Время работы: ежедневно с 9:00 до 21:00 (МСК)',
    socialTitle: 'Социальные сети',
    officeTitle: 'Офис в Дубае',
  },
  en: {
    supportTitle: 'Customer Support',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
    workingHours: 'Working hours: daily 9:00 AM – 9:00 PM (GST)',
    socialTitle: 'Social Media',
    officeTitle: 'Dubai Office',
  },
};

const ContactsPage = () => {
  const { t, i18n } = useTranslation();
  const { isTablet } = useGlobal();

  const lang = i18n.language.startsWith('ru') ? 'ru' : 'en';
  const c = content[lang];
  const email = company.config.email;
  const links = company.config.links;

  return (
    <>
      <MobileHeaderLayout
        content={<MobileHeaderTitle text={t('contacts')} />}
      />
      <div className="content-layout">
        <div className={tp.root}>
          {!isTablet && (
            <Breadcrumbs
              items={
                [
                  { text: t('home'), link: '/' },
                  { text: t('contacts'), link: '/contacts' },
                ].filter(Boolean) as BreadcrumbsItem[]
              }
            />
          )}

          <div className={tp.content}>
            <h1 className={tp.title}>{t('contacts')}</h1>

            <section className={tp.section}>
              <h2 className={tp.subtitle}>{c.supportTitle}</h2>
              <p className={tp.text}>
                {c.emailLabel}:{' '}
                <a href={`mailto:${email}`} className={tp.link}>
                  {email}
                </a>
              </p>
              <p className={tp.text}>
                {c.phoneLabel}:{' '}
                <a
                  href={`tel:${company.config.phoneNumber}`}
                  className={tp.link}
                >
                  {company.config.phoneNumber}
                </a>
              </p>
              <p className={tp.text}>{c.workingHours}</p>
            </section>

            <section className={tp.section}>
              <h2 className={tp.subtitle}>{c.socialTitle}</h2>
              {links.tg && (
                <p className={tp.text}>
                  Telegram:{' '}
                  <a
                    href={links.tg}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={tp.link}
                  >
                    {links.tg.replace('https://', '')}
                  </a>
                </p>
              )}
              {links.vk && (
                <p className={tp.text}>
                  VK:{' '}
                  <a
                    href={links.vk}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={tp.link}
                  >
                    {links.vk.replace('https://', '')}
                  </a>
                </p>
              )}
              {links.instagram && (
                <p className={tp.text}>
                  Instagram:{' '}
                  <a
                    href={links.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={tp.link}
                  >
                    {links.instagram.replace('https://www.', '')}
                  </a>
                </p>
              )}
            </section>

            <section className={tp.section}>
              <h2 className={tp.subtitle}>{c.officeTitle}</h2>
              <p className={tp.text}>
                05 Al Manara Building, Khalifa Industrial Area
              </p>
              <p className={tp.text}>Abu Dhabi Ports Company PJSC</p>
              <p className={tp.text}>Abu Dhabi, United Arab Emirates</p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactsPage;
